/* eslint-disable camelcase */
import { useEffect } from 'react';
import { useStore } from 'store';
import { Col, Container, Row, Button, Image, ProgressBar } from 'react-bootstrap';
import _isEmpty from 'lodash/isEmpty';
import bankCardIcon from 'assets/img/bank-card-icon.svg';
import weddingRing from 'assets/img/wedding-ring.svg';
import { Link } from 'react-router-dom';
// import { useStorage64 } from 'hooks';
import CurrencyFormat from 'components/Helpers/CurrencyFormat';
// import { CURRENT_GIFT_TABLE } from 'constants/storage64';
import { fetchGiftTableInfo } from 'store/actions/giftTable';
import { useWindowSize } from 'hooks';

export default function GiftsReceivedLayout2({
  children,
  className = '',
  showAccumulatedAmount = true,
  title = 'Mis regalos recibidos',
  showNameEvent =  true,
  id,
  agent,
  adminheader = sessionStorage.getItem('admin_header')
}) {
  const [, { isMobile }] = useWindowSize();
  // const [storageGiftTable] = useStorage64(CURRENT_GIFT_TABLE, {});
  const [tableInfo, dispatch] = useStore(
    (state) => state.giftTable.giftTableInfo.data
  );
  //const adminheader = sessionStorage.getItem('admin_header');
  console.log('HEADERADMIN22',adminheader);

  useEffect(() => {
    if (_isEmpty(tableInfo)) {
      dispatch(fetchGiftTableInfo({ id, showLoader: true }));
    }
  }, [tableInfo, id]);

  const MyProgressBar = ({ value, max }) => {
    const progress = (value / max) * 100;

    return (
      <ProgressBar now={progress} label={`${value} de ${max}`} />
    );
  };

  const maxValue = 5000;
  let restan = maxValue - tableInfo?.total_purchases;

  return (
    <Container className={`mb-5 mt-2 pb-3 ${className}`}>
      <Row>
        <Col>
          {
            showNameEvent && <h2 className="font-weight-bold my-1 h4 h-md-2 text-center">{tableInfo?.name}</h2>
          }
          {/*<h3 className="my-1 d-none d-md-block">#Evento {tableInfo?.id}</h3>*/}
        </Col>
      </Row>

      {showAccumulatedAmount && (
        <>
          <Row className="mb-3 mb-md-2 mt-5 mt-md-3">
            <Col xs={12} md={6}>
              <h2 className="text-primary font-weight-bold h5 h-md-2 text-center text-md-left">
                Total acumulado:{' '}
                <CurrencyFormat
                  className="d-inline"
                  price={tableInfo?.total_purchases}
                />
              </h2>
            </Col>
            <Col
              xs={12}
              md={6}
              className="text-right d-flex align-items-center justify-content-center justify-content-md-end my-2 my-md-0"
            >
            </Col>
          </Row>
          <Row>
            <MyProgressBar value={tableInfo?.total_purchases} max={maxValue} isMobile={isMobile} />
             <img src={weddingRing} />
          </Row>
          <Row>
            {
              restan > 0  ? <p>¡Te faltan <CurrencyFormat className="d-inline" price={restan} /> para desbloquear tu regalo</p>
                          : <p>Desbloqueaste tu regalo</p> 
            }
          </Row>
          <Row>
            {
              tableInfo?.wallet
                ? <Link className="link-button" to={agent ? `/my-wallet?agent_staff=${agent}&admin=${adminheader}` : `/my-wallet?admin=${adminheader}`}>
                  <Button>
                    <Image
                      className="mr-3 mb-1"
                      src={bankCardIcon}
                      alt="Bank card icon"
                    />
                    Ver monedero SEARS
                  </Button>
                </Link>
                : null
              }
          </Row>
        </>
      )}

      <>{children}</>
    </Container>
  );
}
